import React, { useState } from "react";
import { Container, Card, Form, Button } from "react-bootstrap";
import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import ClientFooter from "../ClientLayout/ClientFooter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../Constant.js";
import { useNavigate } from "react-router-dom";

const questions = [
  {
    complaintType: "Physical Complaints",
    question: "Have you ever experienced a traumatic event?",
    fieldName: "physicalTrauma"
  },
  {
    complaintType: "Physical Complaints",
    question: "Do you have a history of substance abuse?",
    fieldName: "physicalSubstanceAbuse"
  },
  {
    complaintType: "Physical Complaints",
    question: "Have you ever had suicidal thoughts?",
    fieldName: "physicalSuicidalThoughts"
  },
  {
    complaintType: "Social Complaints",
    question: "Have you ever experienced a traumatic event?",
    fieldName: "socialTrauma"
  },
  {
    complaintType: "Social Complaints",
    question: "Do you have a history of substance abuse?",
    fieldName: "socialSubstanceAbuse"
  },
  {
    complaintType: "Social Complaints",
    question: "Have you ever had suicidal thoughts?",
    fieldName: "socialSuicidalThoughts"
  },
  {
    complaintType: "Psychological Complaints",
    question: "Have you ever experienced a traumatic event?",
    fieldName: "psychologicalTrauma"
  },
  {
    complaintType: "Psychological Complaints",
    question: "Do you have a history of substance abuse?",
    fieldName: "psychologicalSubstanceAbuse"
  },
  {
    complaintType: "Psychological Complaints",
    question: "Have you ever had suicidal thoughts?",
    fieldName: "psychologicalSuicidalThoughts"
  }
];

// Group questions by complaint type
const groupedQuestions = Object.entries(
  questions.reduce((acc, q) => {
    if (!acc[q.complaintType]) {
      acc[q.complaintType] = [];
    }
    acc[q.complaintType].push(q);
    return acc;
  }, {})
);

const PsychologicalInformation = () => {
   const navigate = useNavigate();
  const [loginId, setLoginId] = useState(localStorage.getItem("loginId"));
  const [answers, setAnswers] = useState({});

  const handleOptionChange = (fieldName, value) => {
    setAnswers(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginId) {
      toast.error("Please enter your Login ID.");
      return;
    }
    // Create an array of responses, one record per question
    const responses = questions.map(q => ({
      LoginId: parseInt(loginId, 10),
      Question: q.question,
      SelectedOption: answers[q.fieldName] || "",
      ComplaintType: q.complaintType,
      CreatedOn: new Date()
    }));

    try {
      const response = await fetch(`${API_URL}api/psychologicalinformation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(responses)
      });
      const result = await response.json();
      if (response.ok) {
        toast.success("Information submitted successfully");
        navigate("/client/ClientCounsellorList");
      } else {
        toast.error("Submission failed: " + result.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while submitting the information.");
    }
  };

  return (
    <>
      <ToastContainer />
      <CommonNavbar />
      <Container className="d-flex justify-content-center mt-4">
        <Card className="shadow p-4" style={{ maxWidth: "800px", width: "100%" }}>
          <Card.Body>
            <h4 className="text-center">Psychological Information</h4>
            <hr />
            <Form onSubmit={handleSubmit} style={{ paddingLeft: "40px" }}>
              {groupedQuestions.map(([complaintType, questionsArray], index) => (
                <div key={index} className="mb-4">
                  <h5>{complaintType}</h5>
                  {questionsArray.map((q, idx) => (
                    <Form.Group className="mb-3" key={idx}>
                      <Form.Label>{q.question}</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          label="Yes"
                          name={q.fieldName}
                          id={`${q.fieldName}-yes`}
                          onChange={() => handleOptionChange(q.fieldName, "Yes")}
                          checked={answers[q.fieldName] === "Yes"}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="No"
                          name={q.fieldName}
                          id={`${q.fieldName}-no`}
                          onChange={() => handleOptionChange(q.fieldName, "No")}
                          checked={answers[q.fieldName] === "No"}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="Prefer not to say"
                          name={q.fieldName}
                          id={`${q.fieldName}-prefer-not`}
                          onChange={() => handleOptionChange(q.fieldName, "Prefer not to say")}
                          checked={answers[q.fieldName] === "Prefer not to say"}
                        />
                      </div>
                    </Form.Group>
                  ))}
                </div>
              ))}
              <div className="text-center">
                <Button type="submit" variant="primary">
                  Submit
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <ClientFooter />
    </>
  );
};

export default PsychologicalInformation;
